import React, { Node} from 'react';
import _ from 'lodash';

export function highlightCards(text, mappings) {
  return _.reduce(mappings, (p, c) => {
    const cardName = c.name;
    const cardUrl = c.url;
    const escapedCardName = cardName ? cardName.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&') : '';
    const searchRegex = new RegExp(escapedCardName, 'g');

    if (!cardName || !cardUrl) {
      return p;
    }

    return _(p)
      .map(t => {
        if (typeof t === 'string') {
          return t.split(searchRegex)
            .reduce((prev, curr) => prev.length ? [...prev, <a target="_blank" href={cardUrl}>{cardName}</a>, curr] : [curr], [])
        } else {
          return t;
        }
      })
      .flatten()
      .value();
    
  }, [text]).map((t, i) => <React.Fragment key={i}>{t}</React.Fragment>);
}

export default {
  highlightCards,
};
